(function() {
    'use strict';
    angular
        .module('MW.ContactManager.ContactManagerOutreachStatsAnalyticsController', [
            'MW.Framework.TranslationService',
            'MW.Framework.PredictionPanelService',
            'MW.Framework.ContentStreamSelectionDecorator',
            'MW.ContactManager.ContactManagerActionBarFactory',
            'MW.Framework.ICMEmailService',
            'MW.Framework.GenericHighchart',
            'CoreChartObject',
            'MW.Framework.CoreCommon',
            'MW.ContactManager.TransformOutreachStatsChart',
            'ngSanitize',
            'CoreColorService',
            'MW.Configuration',
            'MW.CoreStream.CsSelectAllHeader',
            'MW.Influencers.IcmDialogService'
        ])
        .controller('ContactManagerOutreachStatsAnalyticsController', [
            'translationService',
            'PredictionPanelService',
            'ContactManagerActionBarFactory',
            'ICMEmailService',
            'DialogService',
            'Contact',
            'ContentStreamSelectionDecorator',
            'CoreChartObject',
            'CoreCommon',
            'TransformOutreachStatsChartService',
            'CoreColorService',
            '$sce',
            ContactManagerOutreachStatsAnalyticsController
        ]);

    function ContactManagerOutreachStatsAnalyticsController(
        translationService,
        PredictionPanelService,
        ContactManagerActionBarFactory,
        ICMEmailService,
        DialogService,
        Contact,
        ContentStreamSelectionDecorator,
        CoreChartObject,
        CoreCommon,
        TransformOutreachStatsChartService,
        CoreColorService,
        $sce
    ) {
        var prepareContactData;

        this.translationService = translationService;
        this.PredictionPanelService = PredictionPanelService;
        this.CoreChartObject = CoreChartObject;
        this.CoreCommon = CoreCommon;
        this.TransformOutreachStatsChartService = TransformOutreachStatsChartService;
        this.CoreColorService = CoreColorService;
        this.$sce = $sce;
        this.DialogService = DialogService;

        this.ContactSelector = new ContentStreamSelectionDecorator({
            idField: 'id',
            filterName: 'contactFilter'
        });

        this.ContactManagerActionBarFactory = new ContactManagerActionBarFactory(this.ContactSelector);
        this.ICMEmailService = ICMEmailService;

        this.sortField = 'alphabetically';
        this.predictionContactFilter = {};
        this.predictionContactValues = [];
        this.contactPredictionPanelExpanded = false;
        this.enableAddtoList = false;
        this.Contact = Contact;
        this.allText = this.translationService.getLocalizedString('All');

        this._setupContactPredictionValues = function _setupContactPredictionValues() {
            this.predictionContactValues = this.PredictionPanelService.buildContactPredictionValues(this.ContactStreamData.contactArray);
        };


        this.showActionButtons = function showActionButtons() {
            var keys = Object.keys(this.ContactSelector.selectedItems);
            return keys.length > 0;
        };

        /**
         * @description Processing Query to get response for contactIds
         *
         * @param [array] Contact Ids Array
         * @param [array] Email Address Array
         * @param {object} recipientsMap object
         */
        this.processQuery = function processQuery(contactIdsArray, emailAddressArray, recipientsMap){
            var query = {},
                processQueryPayload = {},
                // if you have a list over this size you're not going to have a good time - GYDA-25723
                amountToDisplayProperlySize = 1000;

            query = {'anyKeywords': contactIdsArray, 'page': 0, 'pageSize': amountToDisplayProperlySize};
            processQueryPayload = {'contactIdsArray': contactIdsArray, 'emailAddressArray': emailAddressArray, 'recipientsMap': recipientsMap};

            this.ContactStreamData.getByContactIds(query).then(function(response) {
                this.processContactArray(response, processQueryPayload);
                this._setupContactPredictionValues();
            }.bind(this));
        };

        /**
         * @description Processing Contact Array on the basis of response of contactIds and QueryPayload
         *
         * @param [array] contact Result Array is hits array
         * @param {object} Query Payload object
         */
        this.processContactArray = function processContactArray(contactResultArray, queryPayload){
            var contactObjMap = {},
                removedContactIds = [],
                i;

            //creating contact object map, passing whole contact object mapping to contact id
            for(i=0; i<contactResultArray.hits.length; i++) {
                contactObjMap[contactResultArray.hits[i].id] = contactResultArray.hits[i];
            }

            //checking of contact in contactObjMap and pushing in removedContactIds if undefined
            for(i=0; i<queryPayload.contactIdsArray.length; i++){
                if(!contactObjMap[queryPayload.contactIdsArray[i]]) {
                    removedContactIds.push(queryPayload.contactIdsArray[i]);
                }
            }

            // pushing emailAddress of removed contact id to emailAddressArray
            if(removedContactIds && queryPayload.recipientsMap) {
                for(i=0; i<removedContactIds.length; i++){
                    if(queryPayload.recipientsMap[removedContactIds[i]]) {
                        queryPayload.emailAddressArray.push(queryPayload.recipientsMap[removedContactIds[i]]);
                    }
                }
            }

            queryPayload.emailAddressArray.sort();

            //call addOtherContactsToArray function to create particuler contact with email
            if(queryPayload.emailAddressArray){
                for(i=0; i<queryPayload.emailAddressArray.length; i++){
                    this.addOtherContactsToArray(contactResultArray, queryPayload.emailAddressArray[i]);
                }
            }

            //setting final created contactArray to ContactStreamData.contactArray
            if(contactResultArray.hits) {
                this.ContactStreamData.contactArray = contactResultArray.hits;
            }
        };

        /**
         * @description adding Other type Contacts To Array
         *
         * @param [array] contact Result Array is hits array
         * @param {string} Email Address string
         */
        this.addOtherContactsToArray = function addOtherContactsToArray(contactResultArray, emailAddress){
            contactResultArray.hits.push(new this.Contact({
                contactInfo:{
                    email:[{
                        address: emailAddress,
                        _quiddityType: 'common.Email',
                        type: 'work'
                    }]
                },
                id: 'other_contact_' + this.ContactStreamData.totalContacts,
                systemData: {}
            }));
            this.ContactStreamData.totalContacts++;
        };

        this.resetSelections = function resetSelections() {
            this.ContactSelector.deselectAll();
        };

        /**
         * @description Prepareing contactIdsArray, recipientsMap and emailAddressArray
         *
         * @param {object} contact object
         * @param [array] existingContactIds Array
         * @param [array] existingEmailAddress Array
         */
        prepareContactData = function prepareContactData(contactObj, existingContactIds, existingEmailAddress){
            var contactIdsArray = existingContactIds || [],
                emailAddressArray = existingEmailAddress || [],
                recipientsMap = {};
            if(contactObj.contactId) {
                contactIdsArray.push(contactObj.contactId);
                recipientsMap[contactObj.contactId] = contactObj.emailAddress;
            } else {
                emailAddressArray.push(contactObj.emailAddress);
            }

            return {
                contactIdsArray: contactIdsArray,
                emailAddressArray: emailAddressArray,
                recipientsMap: recipientsMap
            };
        };
    }
}());
